/**
 * Admin section layout (§21) — a routed <Outlet/> for the config views. Views are
 * read-only for MANAGER and editable for ADMIN (§B/§C).
 *
 * Task 7 — the admin sub-surfaces are now navigated from the sidebar's collapsible
 * "Settings" group (see AppLayout), so this layout no longer renders its own
 * horizontal sub-nav (that would duplicate the sidebar). It stays as a thin
 * wrapper so the route tree + section spacing are unchanged.
 */
import { Outlet } from "react-router-dom";

export function AdminLayout() {
  return (
    <div className="admin-section">
      <Outlet />
    </div>
  );
}
